import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.ProfileEditPopup', {
    confirmationTitle: 'Unsaved changes',
    confirmationMessage:
        'There are unsaved changes on the page.{br} Would you like to discard them or continue editing?',
    confirmationButtonCancel: 'Continue editing',
    confirmationButtonConfirm: 'Discard changes',
});
